const STATE_COLORS: Record<string, string> = {
  in_flight: 'bg-amber-100 text-amber-900',
  returned: 'bg-amber-100 text-amber-900',
  completed: 'bg-emerald-100 text-emerald-900',
  failed: 'bg-red-100 text-red-900',
};

export function CeremonyStateBadge({ state }: { state: string }) {
  const classes = STATE_COLORS[state] ?? 'bg-neutral-100 text-neutral-900';
  return (
    <span className={`inline-block rounded px-2 py-0.5 text-xs font-medium ${classes}`}>
      {state}
    </span>
  );
}
